// US State Capitals (lat/lon)
const STATE_CAPITALS = [
  { state: 'Alabama', capital: 'Montgomery', lat: 32.377716, lon: -86.300568 },
  { state: 'Alaska', capital: 'Juneau', lat: 58.301598, lon: -134.420212 },
  { state: 'Arizona', capital: 'Phoenix', lat: 33.448143, lon: -112.096962 },
  { state: 'Arkansas', capital: 'Little Rock', lat: 34.746613, lon: -92.288986 },
  { state: 'California', capital: 'Sacramento', lat: 38.576668, lon: -121.493629 },
  { state: 'Colorado', capital: 'Denver', lat: 39.739227, lon: -104.984856 },
  { state: 'Connecticut', capital: 'Hartford', lat: 41.764046, lon: -72.682198 },
  { state: 'Delaware', capital: 'Dover', lat: 39.157307, lon: -75.519722 },
  { state: 'Florida', capital: 'Tallahassee', lat: 30.438118, lon: -84.281296 },
  { state: 'Georgia', capital: 'Atlanta', lat: 33.749027, lon: -84.388229 },
  { state: 'Hawaii', capital: 'Honolulu', lat: 21.307442, lon: -157.857376 },
  { state: 'Idaho', capital: 'Boise', lat: 43.617775, lon: -116.199722 },
  { state: 'Illinois', capital: 'Springfield', lat: 39.798363, lon: -89.654961 },
  { state: 'Indiana', capital: 'Indianapolis', lat: 39.768623, lon: -86.162643 },
  { state: 'Iowa', capital: 'Des Moines', lat: 41.591087, lon: -93.603729 },
  { state: 'Kansas', capital: 'Topeka', lat: 39.048191, lon: -95.677956 },
  { state: 'Kentucky', capital: 'Frankfort', lat: 38.186722, lon: -84.875374 },
  { state: 'Louisiana', capital: 'Baton Rouge', lat: 30.457069, lon: -91.187393 },
  { state: 'Maine', capital: 'Augusta', lat: 44.307167, lon: -69.781693 },
  { state: 'Maryland', capital: 'Annapolis', lat: 38.978764, lon: -76.490936 },
  { state: 'Massachusetts', capital: 'Boston', lat: 42.358162, lon: -71.063698 },
  { state: 'Michigan', capital: 'Lansing', lat: 42.733635, lon: -84.555328 },
  { state: 'Minnesota', capital: 'St. Paul', lat: 44.955097, lon: -93.102211 },
  { state: 'Mississippi', capital: 'Jackson', lat: 32.303848, lon: -90.182106 },
  { state: 'Missouri', capital: 'Jefferson City', lat: 38.579201, lon: -92.172935 },
  { state: 'Montana', capital: 'Helena', lat: 46.585709, lon: -112.018417 },
  { state: 'Nebraska', capital: 'Lincoln', lat: 40.808075, lon: -96.699654 },
  { state: 'Nevada', capital: 'Carson City', lat: 39.163914, lon: -119.766121 },
  { state: 'New Hampshire', capital: 'Concord', lat: 43.20725, lon: -71.536604 },
  { state: 'New Jersey', capital: 'Trenton', lat: 40.22039, lon: -74.76432 },
  { state: 'New Mexico', capital: 'Santa Fe', lat: 35.68224, lon: -105.939728 },
  { state: 'New York', capital: 'Albany', lat: 42.652843, lon: -73.757874 },
  { state: 'North Carolina', capital: 'Raleigh', lat: 35.78043, lon: -78.639099 },
  { state: 'North Dakota', capital: 'Bismarck', lat: 46.82085, lon: -100.783318 },
  { state: 'Ohio', capital: 'Columbus', lat: 39.961346, lon: -82.999069 },
  { state: 'Oklahoma', capital: 'Oklahoma City', lat: 35.492207, lon: -97.503342 },
  { state: 'Oregon', capital: 'Salem', lat: 44.938461, lon: -123.030403 },
  { state: 'Pennsylvania', capital: 'Harrisburg', lat: 40.264378, lon: -76.883598 },
  { state: 'Rhode Island', capital: 'Providence', lat: 41.830914, lon: -71.414963 },
  { state: 'South Carolina', capital: 'Columbia', lat: 34.000343, lon: -81.033211 },
  { state: 'South Dakota', capital: 'Pierre', lat: 44.367031, lon: -100.346405 },
  { state: 'Tennessee', capital: 'Nashville', lat: 36.16581, lon: -86.784241 },
  { state: 'Texas', capital: 'Austin', lat: 30.27467, lon: -97.740349 },
  { state: 'Utah', capital: 'Salt Lake City', lat: 40.777477, lon: -111.888237 },
  { state: 'Vermont', capital: 'Montpelier', lat: 44.262436, lon: -72.580536 },
  { state: 'Virginia', capital: 'Richmond', lat: 37.538857, lon: -77.43364 },
  { state: 'Washington', capital: 'Olympia', lat: 47.035805, lon: -122.905014 },
  { state: 'West Virginia', capital: 'Charleston', lat: 38.336246, lon: -81.612328 },
  { state: 'Wisconsin', capital: 'Madison', lat: 43.074684, lon: -89.384445 },
  { state: 'Wyoming', capital: 'Cheyenne', lat: 41.140259, lon: -104.820236 },
];
export default STATE_CAPITALS;